export enum PROJECT_ACCESS_LEVELS {
  UNKNOWN = 'unknown',
  MEMBER = 'member'
}

export default PROJECT_ACCESS_LEVELS;
